import BaseElement from './BaseElement'
import { WishlistDashboard } from '../components/WishlistDashboard';

export default class WishlistDashboardElement extends BaseElement {
  renderElement () {
    this.rootElement?.render(<WishlistDashboard showListPageTitle={false} />)
  }
}
